// ADE Privacy Policy — 5 languages (it, en, es, fr, de)
// Structure: { title, version, sections: [{ h, p?, ul?, p2? }], footer } — **bold** and [label](url) supported

export const PRIVACY_CONTENT = {
  it: {
    title: "Informativa sulla Privacy",
    version: "Ultimo aggiornamento: Agosto 2026",
    footer: "Versione documento: 1.0 — Titolare: A.d.E - Around. Discover. Engage, Via Marie Curie 17, 39100 Bolzano (BZ)",
    sections: [
      { h: "1. Titolare del Trattamento", p: [
        "**A.d.E - Around. Discover. Engage**",
        "Sede Legale: Via Marie Curie 17, 39100 Bolzano (BZ) — Italia",
        "P.IVA / C.F.: 03062850999",
        "REA: GE — 531489",
        "PEC: [arabellgroupsrls@legalmail.it](mailto:arabellgroupsrls@legalmail.it)",
        "Email Privacy: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
      ]},
      { h: "2. Dati Raccolti", p: ["Raccogliamo i seguenti dati:"], ul: [
        "**Dati di registrazione:** nome, email, password (crittografata), paese, username",
        "**Dati di profilo:** foto profilo, copertina, bio, età, città",
        "**Dati di geolocalizzazione:** coordinate GPS (solo con consenso esplicito)",
        "**Contenuti generati:** foto, commenti, messaggi, storie",
        "**Dati di utilizzo:** collegamenti, likes, regali, transazioni ADE Coins",
      ]},
      { h: "3. Base Giuridica (Art. 6 GDPR)", ul: [
        "**Consenso esplicito** (Art. 6.1.a): geolocalizzazione, comunicazioni marketing",
        "**Esecuzione del contratto** (Art. 6.1.b): funzionamento dell'app, gestione account",
        "**Interesse legittimo** (Art. 6.1.f): sicurezza, prevenzione abusi",
      ]},
      { h: "4. Finalità del Trattamento", ul: [
        "Fornire il servizio di social networking di prossimità",
        "Mostrare utenti nelle vicinanze tramite GPS",
        "Gestire collegamenti, messaggi e contenuti",
        "Elaborare transazioni ADE Coins e regali",
        "Inviare notifiche push (con consenso)",
        "Comunicazioni marketing (solo con consenso)",
      ]},
      { h: "5. Conservazione dei Dati", ul: [
        "**Dati account:** fino alla cancellazione dell'account",
        "**Posizione GPS:** ultime 24 ore di cronologia, poi cancellata automaticamente",
        "**Storie:** 24 ore, poi cancellate automaticamente",
        "**Messaggi:** fino alla cancellazione dell'account",
        "**Dati di pagamento:** gestiti da Stripe (PCI-DSS compliant)",
      ]},
      { h: "6. I Tuoi Diritti (Art. 15-22 GDPR)", p: ["Hai diritto a:"], ul: [
        "**Accesso** (Art. 15): vedere tutti i tuoi dati",
        "**Rettifica** (Art. 16): correggere i tuoi dati",
        "**Cancellazione** (Art. 17): eliminare il tuo account e tutti i dati",
        "**Portabilità** (Art. 20): esportare i tuoi dati in formato leggibile",
        "**Revoca consenso** (Art. 7.3): revocare qualsiasi consenso in qualsiasi momento",
        "**Opposizione** (Art. 21): opporti al trattamento per marketing",
      ], p2: [
        "Per esercitare i tuoi diritti: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
        "Oppure direttamente dall'app: **Impostazioni → Sicurezza → Esporta/Elimina Dati**",
      ]},
      { h: "7. Condivisione con Terze Parti", ul: [
        "**Stripe:** elaborazione pagamenti (solo dati di transazione)",
        "**Google:** autenticazione OAuth (solo email e nome)",
        "Non vendiamo i tuoi dati a terze parti",
        "Non condividiamo dati di geolocalizzazione con terze parti",
      ]},
      { h: "8. Sicurezza", p: ["Proteggiamo i tuoi dati con:"], ul: [
        "Crittografia delle password (bcrypt)",
        "Comunicazioni HTTPS/TLS",
        "Token JWT con scadenza",
        "Rate limiting sulle API",
      ]},
      { h: "9. Età Minima", p: [
        "L'app è destinata a utenti di **almeno 16 anni** di età (Art. 8 GDPR). Registrandoti dichiari di avere almeno 16 anni.",
      ]},
      { h: "10. Reclami", p: [
        "Se ritieni che il trattamento dei tuoi dati violi il GDPR, puoi presentare reclamo al **Garante per la Protezione dei Dati Personali** ([www.garanteprivacy.it](https://www.garanteprivacy.it)).",
      ]},
      { h: "11. Cookie", p: [
        "ADE utilizza esclusivamente cookie tecnici necessari per il funzionamento dell'app (sessione di autenticazione). Non utilizziamo cookie di profilazione o di terze parti per finalità di marketing.",
      ]},
      { h: "12. ADE Coins", p: [
        "Gli ADE Coins sono **crediti interni della piattaforma** utilizzabili esclusivamente all'interno dell'ecosistema ADE. **Non** costituiscono:",
      ], ul: [
        "Moneta elettronica, criptovaluta, valuta bancaria o strumento finanziario",
        "Investimento con aspettativa di rendimento",
        "Deposito bancario, conto corrente o prodotto finanziario",
      ], p2: [
        "Gli ADE Coins non sono convertibili in denaro, non producono interessi, non sono prelevabili e non sono negoziabili su mercati esterni. Il loro utilizzo è limitato all'acquisto di Gift e contenuti digitali all'interno della piattaforma ADE.",
      ]},
    ],
  },

  en: {
    title: "Privacy Policy",
    version: "Last updated: August 2026",
    footer: "Document version: 1.0 — Controller: A.d.E - Around. Discover. Engage, Via Marie Curie 17, 39100 Bolzano (BZ), Italy",
    sections: [
      { h: "1. Data Controller", p: [
        "**A.d.E - Around. Discover. Engage**",
        "Registered Office: Via Marie Curie 17, 39100 Bolzano (BZ) — Italy",
        "VAT/Tax code: 03062850999",
        "REA: GE — 531489",
        "Certified email (PEC): [arabellgroupsrls@legalmail.it](mailto:arabellgroupsrls@legalmail.it)",
        "Privacy Email: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
      ]},
      { h: "2. Data Collected", p: ["We collect the following data:"], ul: [
        "**Registration data:** name, email, password (encrypted), country, username",
        "**Profile data:** profile picture, cover, bio, age, city",
        "**Geolocation data:** GPS coordinates (only with explicit consent)",
        "**Generated content:** photos, comments, messages, stories",
        "**Usage data:** connections, likes, gifts, ADE Coins transactions",
      ]},
      { h: "3. Legal Basis (Art. 6 GDPR)", ul: [
        "**Explicit consent** (Art. 6.1.a): geolocation, marketing communications",
        "**Performance of the contract** (Art. 6.1.b): app operation, account management",
        "**Legitimate interest** (Art. 6.1.f): security, abuse prevention",
      ]},
      { h: "4. Purposes of Processing", ul: [
        "Provide the proximity-based social networking service",
        "Display nearby users via GPS",
        "Manage connections, messages and content",
        "Process ADE Coins transactions and gifts",
        "Send push notifications (with consent)",
        "Marketing communications (with consent only)",
      ]},
      { h: "5. Data Retention", ul: [
        "**Account data:** until the account is deleted",
        "**GPS location:** last 24 hours of history, then automatically deleted",
        "**Stories:** 24 hours, then automatically deleted",
        "**Messages:** until the account is deleted",
        "**Payment data:** handled by Stripe (PCI-DSS compliant)",
      ]},
      { h: "6. Your Rights (Art. 15-22 GDPR)", p: ["You have the right to:"], ul: [
        "**Access** (Art. 15): view all your data",
        "**Rectification** (Art. 16): correct your data",
        "**Erasure** (Art. 17): delete your account and all data",
        "**Portability** (Art. 20): export your data in a readable format",
        "**Withdraw consent** (Art. 7.3): withdraw any consent at any time",
        "**Object** (Art. 21): object to processing for marketing",
      ], p2: [
        "To exercise your rights: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
        "Or directly in the app: **Settings → Security → Export/Delete Data**",
      ]},
      { h: "7. Sharing with Third Parties", ul: [
        "**Stripe:** payment processing (transaction data only)",
        "**Google:** OAuth authentication (email and name only)",
        "We do not sell your data to third parties",
        "We do not share geolocation data with third parties",
      ]},
      { h: "8. Security", p: ["We protect your data with:"], ul: [
        "Password encryption (bcrypt)",
        "HTTPS/TLS communications",
        "JWT tokens with expiration",
        "API rate limiting",
      ]},
      { h: "9. Minimum Age", p: [
        "The app is intended for users **at least 16 years old** (Art. 8 GDPR). By registering, you declare that you are at least 16 years old.",
      ]},
      { h: "10. Complaints", p: [
        "If you believe that the processing of your data infringes the GDPR, you may lodge a complaint with the **Italian Data Protection Authority** ([www.garanteprivacy.it](https://www.garanteprivacy.it)).",
      ]},
      { h: "11. Cookies", p: [
        "ADE uses only technical cookies necessary for the app to operate (authentication session). We do not use profiling or third-party cookies for marketing purposes.",
      ]},
      { h: "12. ADE Coins", p: [
        "ADE Coins are **internal platform credits** usable exclusively within the ADE ecosystem. They **do not** constitute:",
      ], ul: [
        "Electronic money, cryptocurrency, bank currency or a financial instrument",
        "An investment with an expectation of return",
        "A bank deposit, current account or financial product",
      ], p2: [
        "ADE Coins are not convertible into money, bear no interest, are not withdrawable and are not tradable on external markets. Their use is limited to purchasing Gifts and digital content within the ADE platform.",
      ]},
    ],
  },

  es: {
    title: "Política de Privacidad",
    version: "Última actualización: Agosto 2026",
    footer: "Versión del documento: 1.0 — Responsable: A.d.E - Around. Discover. Engage, Via Marie Curie 17, 39100 Bolzano (BZ), Italia",
    sections: [
      { h: "1. Responsable del Tratamiento", p: [
        "**A.d.E - Around. Discover. Engage**",
        "Domicilio social: Via Marie Curie 17, 39100 Bolzano (BZ) — Italia",
        "CIF/NIF: 03062850999",
        "REA: GE — 531489",
        "PEC: [arabellgroupsrls@legalmail.it](mailto:arabellgroupsrls@legalmail.it)",
        "Email Privacidad: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
      ]},
      { h: "2. Datos Recopilados", p: ["Recopilamos los siguientes datos:"], ul: [
        "**Datos de registro:** nombre, email, contraseña (cifrada), país, nombre de usuario",
        "**Datos de perfil:** foto de perfil, portada, biografía, edad, ciudad",
        "**Datos de geolocalización:** coordenadas GPS (solo con consentimiento explícito)",
        "**Contenidos generados:** fotos, comentarios, mensajes, historias",
        "**Datos de uso:** conexiones, likes, regalos, transacciones de ADE Coins",
      ]},
      { h: "3. Base Jurídica (Art. 6 RGPD)", ul: [
        "**Consentimiento explícito** (Art. 6.1.a): geolocalización, comunicaciones de marketing",
        "**Ejecución del contrato** (Art. 6.1.b): funcionamiento de la app, gestión de cuenta",
        "**Interés legítimo** (Art. 6.1.f): seguridad, prevención de abusos",
      ]},
      { h: "4. Finalidades del Tratamiento", ul: [
        "Prestar el servicio de red social basada en proximidad",
        "Mostrar usuarios cercanos mediante GPS",
        "Gestionar conexiones, mensajes y contenidos",
        "Procesar transacciones de ADE Coins y regalos",
        "Enviar notificaciones push (con consentimiento)",
        "Comunicaciones de marketing (solo con consentimiento)",
      ]},
      { h: "5. Conservación de los Datos", ul: [
        "**Datos de cuenta:** hasta la eliminación de la cuenta",
        "**Ubicación GPS:** últimas 24 horas de historial, luego borrada automáticamente",
        "**Historias:** 24 horas, luego borradas automáticamente",
        "**Mensajes:** hasta la eliminación de la cuenta",
        "**Datos de pago:** gestionados por Stripe (conforme a PCI-DSS)",
      ]},
      { h: "6. Tus Derechos (Art. 15-22 RGPD)", p: ["Tienes derecho a:"], ul: [
        "**Acceso** (Art. 15): ver todos tus datos",
        "**Rectificación** (Art. 16): corregir tus datos",
        "**Supresión** (Art. 17): eliminar tu cuenta y todos los datos",
        "**Portabilidad** (Art. 20): exportar tus datos en formato legible",
        "**Retirada del consentimiento** (Art. 7.3): retirar cualquier consentimiento en cualquier momento",
        "**Oposición** (Art. 21): oponerte al tratamiento con fines de marketing",
      ], p2: [
        "Para ejercer tus derechos: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
        "O directamente desde la app: **Ajustes → Seguridad → Exportar/Eliminar Datos**",
      ]},
      { h: "7. Compartición con Terceros", ul: [
        "**Stripe:** procesamiento de pagos (solo datos de transacción)",
        "**Google:** autenticación OAuth (solo email y nombre)",
        "No vendemos tus datos a terceros",
        "No compartimos datos de geolocalización con terceros",
      ]},
      { h: "8. Seguridad", p: ["Protegemos tus datos con:"], ul: [
        "Cifrado de contraseñas (bcrypt)",
        "Comunicaciones HTTPS/TLS",
        "Tokens JWT con expiración",
        "Rate limiting en las API",
      ]},
      { h: "9. Edad Mínima", p: [
        "La app está destinada a usuarios de **al menos 16 años** de edad (Art. 8 RGPD). Al registrarte declaras tener al menos 16 años.",
      ]},
      { h: "10. Reclamaciones", p: [
        "Si consideras que el tratamiento de tus datos infringe el RGPD, puedes presentar una reclamación ante el **Garante italiano para la Protección de Datos Personales** ([www.garanteprivacy.it](https://www.garanteprivacy.it)) o ante tu autoridad local de control.",
      ]},
      { h: "11. Cookies", p: [
        "ADE utiliza únicamente cookies técnicas necesarias para el funcionamiento de la app (sesión de autenticación). No utilizamos cookies de perfilado ni de terceros con fines de marketing.",
      ]},
      { h: "12. ADE Coins", p: [
        "Los ADE Coins son **créditos internos de la plataforma** utilizables exclusivamente dentro del ecosistema ADE. **No** constituyen:",
      ], ul: [
        "Dinero electrónico, criptomoneda, moneda bancaria ni instrumento financiero",
        "Inversión con expectativa de rendimiento",
        "Depósito bancario, cuenta corriente ni producto financiero",
      ], p2: [
        "Los ADE Coins no son convertibles en dinero, no generan intereses, no son retirables y no son negociables en mercados externos. Su uso se limita a la compra de Gifts y contenidos digitales dentro de la plataforma ADE.",
      ]},
    ],
  },

  fr: {
    title: "Politique de Confidentialité",
    version: "Dernière mise à jour : Août 2026",
    footer: "Version du document : 1.0 — Responsable du traitement : A.d.E - Around. Discover. Engage, Via Marie Curie 17, 39100 Bolzano (BZ), Italie",
    sections: [
      { h: "1. Responsable du Traitement", p: [
        "**A.d.E - Around. Discover. Engage**",
        "Siège social : Via Marie Curie 17, 39100 Bolzano (BZ) — Italie",
        "TVA/Code fiscal : 03062850999",
        "REA : GE — 531489",
        "PEC : [arabellgroupsrls@legalmail.it](mailto:arabellgroupsrls@legalmail.it)",
        "Email confidentialité : [privacy@ade-app.com](mailto:privacy@ade-app.com)",
      ]},
      { h: "2. Données Collectées", p: ["Nous collectons les données suivantes :"], ul: [
        "**Données d'inscription :** nom, e-mail, mot de passe (chiffré), pays, nom d'utilisateur",
        "**Données de profil :** photo de profil, couverture, biographie, âge, ville",
        "**Données de géolocalisation :** coordonnées GPS (uniquement avec consentement explicite)",
        "**Contenus générés :** photos, commentaires, messages, stories",
        "**Données d'utilisation :** connexions, likes, cadeaux, transactions ADE Coins",
      ]},
      { h: "3. Base Juridique (Art. 6 RGPD)", ul: [
        "**Consentement explicite** (Art. 6.1.a) : géolocalisation, communications marketing",
        "**Exécution du contrat** (Art. 6.1.b) : fonctionnement de l'app, gestion du compte",
        "**Intérêt légitime** (Art. 6.1.f) : sécurité, prévention des abus",
      ]},
      { h: "4. Finalités du Traitement", ul: [
        "Fournir le service de réseau social basé sur la proximité",
        "Afficher les utilisateurs à proximité via GPS",
        "Gérer les connexions, messages et contenus",
        "Traiter les transactions d'ADE Coins et les cadeaux",
        "Envoyer des notifications push (avec consentement)",
        "Communications marketing (avec consentement uniquement)",
      ]},
      { h: "5. Conservation des Données", ul: [
        "**Données de compte :** jusqu'à la suppression du compte",
        "**Position GPS :** dernières 24 heures d'historique, puis suppression automatique",
        "**Stories :** 24 heures, puis suppression automatique",
        "**Messages :** jusqu'à la suppression du compte",
        "**Données de paiement :** gérées par Stripe (conforme PCI-DSS)",
      ]},
      { h: "6. Vos Droits (Art. 15-22 RGPD)", p: ["Vous avez le droit :"], ul: [
        "**D'accès** (Art. 15) : consulter toutes vos données",
        "**De rectification** (Art. 16) : corriger vos données",
        "**À l'effacement** (Art. 17) : supprimer votre compte et toutes vos données",
        "**À la portabilité** (Art. 20) : exporter vos données dans un format lisible",
        "**De retrait du consentement** (Art. 7.3) : retirer tout consentement à tout moment",
        "**D'opposition** (Art. 21) : vous opposer au traitement à des fins de marketing",
      ], p2: [
        "Pour exercer vos droits : [privacy@ade-app.com](mailto:privacy@ade-app.com)",
        "Ou directement depuis l'app : **Paramètres → Sécurité → Exporter/Supprimer les Données**",
      ]},
      { h: "7. Partage avec des Tiers", ul: [
        "**Stripe :** traitement des paiements (données de transaction uniquement)",
        "**Google :** authentification OAuth (e-mail et nom uniquement)",
        "Nous ne vendons pas vos données à des tiers",
        "Nous ne partageons pas les données de géolocalisation avec des tiers",
      ]},
      { h: "8. Sécurité", p: ["Nous protégeons vos données par :"], ul: [
        "Chiffrement des mots de passe (bcrypt)",
        "Communications HTTPS/TLS",
        "Jetons JWT avec expiration",
        "Limitation de débit sur les API",
      ]},
      { h: "9. Âge Minimum", p: [
        "L'app est destinée aux utilisateurs âgés d'**au moins 16 ans** (Art. 8 RGPD). En vous inscrivant, vous déclarez avoir au moins 16 ans.",
      ]},
      { h: "10. Réclamations", p: [
        "Si vous estimez que le traitement de vos données viole le RGPD, vous pouvez déposer une plainte auprès du **Garante italien pour la Protection des Données Personnelles** ([www.garanteprivacy.it](https://www.garanteprivacy.it)) ou de votre autorité de contrôle locale (en France : CNIL — [www.cnil.fr](https://www.cnil.fr)).",
      ]},
      { h: "11. Cookies", p: [
        "ADE utilise uniquement des cookies techniques nécessaires au fonctionnement de l'app (session d'authentification). Nous n'utilisons pas de cookies de profilage ni de tiers à des fins de marketing.",
      ]},
      { h: "12. ADE Coins", p: [
        "Les ADE Coins sont des **crédits internes de la plateforme** utilisables exclusivement au sein de l'écosystème ADE. Ils **ne** constituent **pas** :",
      ], ul: [
        "De la monnaie électronique, une cryptomonnaie, une monnaie bancaire ou un instrument financier",
        "Un investissement avec attente de rendement",
        "Un dépôt bancaire, un compte courant ou un produit financier",
      ], p2: [
        "Les ADE Coins ne sont pas convertibles en argent, ne produisent pas d'intérêts, ne sont pas retirables et ne sont pas négociables sur des marchés externes. Leur utilisation est limitée à l'achat de Gifts et de contenus numériques au sein de la plateforme ADE.",
      ]},
    ],
  },

  de: {
    title: "Datenschutzerklärung",
    version: "Letzte Aktualisierung: August 2026",
    footer: "Dokumentversion: 1.0 — Verantwortlicher: A.d.E - Around. Discover. Engage, Via Marie Curie 17, 39100 Bolzano (BZ), Italien",
    sections: [
      { h: "1. Verantwortlicher", p: [
        "**A.d.E - Around. Discover. Engage**",
        "Sitz: Via Marie Curie 17, 39100 Bolzano (BZ) — Italien",
        "USt-IdNr./Steuer-Nr.: 03062850999",
        "REA: GE — 531489",
        "PEC: [arabellgroupsrls@legalmail.it](mailto:arabellgroupsrls@legalmail.it)",
        "Datenschutz-E-Mail: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
      ]},
      { h: "2. Erhobene Daten", p: ["Wir erheben folgende Daten:"], ul: [
        "**Registrierungsdaten:** Name, E-Mail, Passwort (verschlüsselt), Land, Benutzername",
        "**Profildaten:** Profilbild, Cover, Bio, Alter, Stadt",
        "**Geolokalisierungsdaten:** GPS-Koordinaten (nur mit ausdrücklicher Einwilligung)",
        "**Erzeugte Inhalte:** Fotos, Kommentare, Nachrichten, Stories",
        "**Nutzungsdaten:** Verbindungen, Likes, Geschenke, ADE-Coins-Transaktionen",
      ]},
      { h: "3. Rechtsgrundlage (Art. 6 DSGVO)", ul: [
        "**Ausdrückliche Einwilligung** (Art. 6 Abs. 1 lit. a): Geolokalisierung, Marketingkommunikation",
        "**Vertragserfüllung** (Art. 6 Abs. 1 lit. b): Betrieb der App, Kontoverwaltung",
        "**Berechtigtes Interesse** (Art. 6 Abs. 1 lit. f): Sicherheit, Missbrauchsprävention",
      ]},
      { h: "4. Zwecke der Verarbeitung", ul: [
        "Bereitstellung des standortbasierten Social-Networking-Dienstes",
        "Anzeige nahegelegener Nutzer via GPS",
        "Verwaltung von Verbindungen, Nachrichten und Inhalten",
        "Verarbeitung von ADE-Coins-Transaktionen und Geschenken",
        "Versand von Push-Benachrichtigungen (mit Einwilligung)",
        "Marketingkommunikation (nur mit Einwilligung)",
      ]},
      { h: "5. Speicherdauer", ul: [
        "**Kontodaten:** bis zur Kontolöschung",
        "**GPS-Standort:** letzte 24 Stunden Verlauf, danach automatische Löschung",
        "**Stories:** 24 Stunden, danach automatische Löschung",
        "**Nachrichten:** bis zur Kontolöschung",
        "**Zahlungsdaten:** verwaltet durch Stripe (PCI-DSS-konform)",
      ]},
      { h: "6. Ihre Rechte (Art. 15-22 DSGVO)", p: ["Sie haben das Recht auf:"], ul: [
        "**Auskunft** (Art. 15): Einsicht in alle Ihre Daten",
        "**Berichtigung** (Art. 16): Korrektur Ihrer Daten",
        "**Löschung** (Art. 17): Löschung Ihres Kontos und aller Daten",
        "**Datenübertragbarkeit** (Art. 20): Export Ihrer Daten in einem lesbaren Format",
        "**Widerruf der Einwilligung** (Art. 7 Abs. 3): jederzeitiger Widerruf einer Einwilligung",
        "**Widerspruch** (Art. 21): Widerspruch gegen Verarbeitung zu Marketingzwecken",
      ], p2: [
        "Zur Ausübung Ihrer Rechte: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
        "Oder direkt in der App: **Einstellungen → Sicherheit → Daten exportieren/löschen**",
      ]},
      { h: "7. Weitergabe an Dritte", ul: [
        "**Stripe:** Zahlungsabwicklung (nur Transaktionsdaten)",
        "**Google:** OAuth-Authentifizierung (nur E-Mail und Name)",
        "Wir verkaufen Ihre Daten nicht an Dritte",
        "Wir geben keine Geolokalisierungsdaten an Dritte weiter",
      ]},
      { h: "8. Sicherheit", p: ["Wir schützen Ihre Daten durch:"], ul: [
        "Passwortverschlüsselung (bcrypt)",
        "HTTPS/TLS-Kommunikation",
        "JWT-Token mit Ablaufdatum",
        "API-Ratenbegrenzung",
      ]},
      { h: "9. Mindestalter", p: [
        "Die App richtet sich an Nutzer ab **mindestens 16 Jahren** (Art. 8 DSGVO). Mit Ihrer Registrierung erklären Sie, mindestens 16 Jahre alt zu sein.",
      ]},
      { h: "10. Beschwerden", p: [
        "Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen die DSGVO verstößt, können Sie eine Beschwerde bei der **italienischen Datenschutzbehörde** ([www.garanteprivacy.it](https://www.garanteprivacy.it)) oder bei Ihrer örtlichen Aufsichtsbehörde einreichen.",
      ]},
      { h: "11. Cookies", p: [
        "ADE verwendet ausschließlich technische Cookies, die für den Betrieb der App erforderlich sind (Authentifizierungssitzung). Wir setzen keine Profiling- oder Drittanbieter-Cookies zu Marketingzwecken ein.",
      ]},
      { h: "12. ADE Coins", p: [
        "ADE Coins sind **interne Plattform-Guthaben**, die ausschließlich innerhalb des ADE-Ökosystems verwendet werden können. Sie stellen **keine**:",
      ], ul: [
        "elektronisches Geld, Kryptowährung, Bankwährung oder Finanzinstrumente",
        "Investition mit Renditeerwartung",
        "Bankeinlage, Girokonto oder Finanzprodukt dar",
      ], p2: [
        "ADE Coins sind nicht in Geld umtauschbar, verzinsen sich nicht, sind nicht abhebbar und nicht an externen Märkten handelbar. Ihre Nutzung ist auf den Kauf von Gifts und digitalen Inhalten innerhalb der ADE-Plattform beschränkt.",
      ]},
    ],
  },
};
